export default __webpack_public_path__ + "static/media/002-cappuccino.93c8bed1.svg";